import { complement, contains, pipe, values } from 'ramda';
import { contained } from 'ramda-adjunct';
import { ExternalSource, MainSource, Source } from '../../../constants/Source';
import { TMMGRSettings } from '../../../utils/hoc/withMMGRSettings/withMMGRSettings.types';

export const getHostBySource = (source: Source, isSecure: boolean, mmgrSettings: TMMGRSettings): string => {
  if (isSecure) {
    return `${mmgrSettings.privateMediaRestAPI}/site/media/files/secure`;
  }

  const isExternalSource = pipe(values, contains(source))(ExternalSource);
  if (isExternalSource && source !== ExternalSource.WixSite) {
    // External sources (except from wix sites) have absolute urls, no need to add host
    return '';
  }

  switch (source) {
    case MainSource.Shutterstock:
    case MainSource.Unsplash:
      return '';

    case MainSource.Recommended:
    case MainSource.MediaFromWix:
      return mmgrSettings.publicMediaRestFiles;

    default:
      return mmgrSettings.privateMediaRestFiles;
  }
};

export const shouldResizeForSource = complement(
  contained([
    ExternalSource.WixVideo,
    ExternalSource.DeviantArt,
    ExternalSource.Dribbble,
    ExternalSource.Dropbox,
    ExternalSource.Facebook,
    ExternalSource.Vimeo,
    ExternalSource.Flickr,
    ExternalSource.GoogleDrive,
    ExternalSource.GooglePhotos,
    ExternalSource.Instagram,
  ]),
);
